module.exports = __webpack_public_path__ + "index_pc/img/icon_sina.45176137.png";